import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=216ffb40&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('216ffb40')) {
      api.createRecord('216ffb40', component.options)
    } else {
      api.reload('216ffb40', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=216ffb40&", function () {
      api.rerender('216ffb40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2X5VA6L14AIik/JS/offershelp.vue"
export default component.exports